import React from 'react';
import {Modal, Table} from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';


const AddressDetailModal = ( props )=>{
    const { name, email, mailerTags} = props.emailAddress;
    const plural = mailerTags.length !== 1?", ":"";

    const {onHide} = props;

    return (
        <Modal
            show={true}
            onHide={ onHide }>
            <Modal.Header closeButton>
                <Modal.Title>Detalle de contacto</Modal.Title>
            </Modal.Header>

            <Modal.Body >
                <div className='AddressDetail'>
                    <Table>
                        <tbody>
                        <tr>
                            <td>Nombre:</td>
                            <td>{name}</td>
                        </tr>
                        <tr>
                            <td>Correo electrónico:</td>
                            <td>{email}</td>
                        </tr>
                        <tr>
                            <td>Grupos de correo:</td>
                            <td>
                                { mailerTags.map((mailerTag,index)=>{
                                    return index===0? <span key={index}>{mailerTag.name}</span>:<span key={index}>{plural}{mailerTag.name}</span>})
                                }
                            </td>
                        </tr>
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AddressDetailModal;



// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/MailManager/components/AddressDetailModal/index.jsx